export default __webpack_public_path__ + "0ad49a7d072fb84be32ac851b379df09.png";